import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Para qué edades sirve este material?',
  a: 'El sistema está dividido en tomos específicos para cada etapa: Infantiles (5 a 12 años), Adolescentes y Adultos. Tendrás recursos adaptados para cualquier grupo que te toque dirigir.'
}, {
  q: '¿En qué formato se entrega?',
  a: 'Es un producto 100% digital en formato PDF de alta calidad. Podés descargarlo en tu celular, tablet o computadora, e incluso imprimir las planillas y ejercicios que necesites llevar a la cancha.'
}, {
  q: '¿Sirve si recién empiezo a dar clases?',
  a: '¡Totalmente! El Tomo 1 está diseñado específicamente para darte las bases pedagógicas y de organización que necesitas para pararte frente a un grupo con seguridad desde el primer día.'
}, {
  q: '¿Cómo accedo al material una vez que pago?',
  a: 'Inmediatamente después de confirmar el pago, recibirás un correo electrónico con el enlace de descarga directa a todo el material y los bonos.'
}, {
  q: '¿Los ejercicios requieren muchos materiales?',
  a: 'No. Si bien hay ejercicios ideales para clubes equipados, incluimos un manual de emergencias y variantes para entrenar en espacios reducidos y con pocos materiales.'
}];
export function Objections() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-white" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <h2 className="text-3xl md:text-4xl font-oswald font-bold text-center text-slate-900 mb-10 uppercase flex items-center justify-center gap-3" data-id="element-111">
          <HelpCircle className="w-8 h-8 text-blue-600" data-id="element-112" />
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-113">
          {faqs.map((faq, index) => <div key={index} className="border border-slate-200 rounded-lg overflow-hidden" data-id="element-114">
              <button onClick={() => toggleFaq(index)} className="w-full text-left px-6 py-4 bg-slate-50 hover:bg-slate-100 flex items-center justify-between transition-colors" data-id="element-115">
                <span className="font-bold text-slate-800 text-lg pr-4" data-id="element-116">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-blue-600 flex-shrink-0" data-id="element-117" /> : <ChevronDown className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-118" />}
              </button>

              {openIndex === index && <div className="px-6 py-4 bg-white border-t border-slate-100" data-id="element-119">
                  <p className="text-slate-600 font-medium leading-relaxed" data-id="element-120">
                    {faq.a}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}